@layer reset, default, variants, hover, active, focus;

@layer reset {
  :host .gcds-nav-link {
    box-sizing: border-box;

    slot {
      display: initial;
    }
  }
}

@layer default {
  :host .gcds-nav-link {
    display: flex;
    font: var(--gcds-nav-link-font);
    text-decoration-style: solid;
    text-decoration-line: underline;
    text-decoration-color: currentColor;
    text-decoration-thickness: var(
      --gcds-nav-link-default-decoration-thickness
    );
    text-underline-offset: var(--gcds-nav-link-default-underline-offset);
    color: var(--gcds-nav-link-default-text);
    margin-block-end: var(--gcds-nav-link-margin);
    padding: var(--gcds-nav-link-padding);
    border-inline: var(--gcds-nav-link-border-width) solid transparent;
    transition: all 0.25s ease-in-out;

    @media only screen and (width < 64em) {
      font: var(--gcds-nav-link-font-mobile);
      min-width: 50%;
    }

    @media only screen and (width > 48em) {
      max-width: var(--gcds-nav-link-default-max-width);
    }

    &[aria-current='page'] {
      text-decoration: none;
      pointer-events: none;
    }
  }
}

@layer variants {
  /* Top-nav: styles for larger screens */
  @media only screen and (width >= 64em) {
    :host > .gcds-nav-link--topnav.gcds-nav-link {
      color: var(--gcds-nav-link-top-nav-text);
      margin: var(--gcds-nav-link-top-nav-margin);
      padding: var(--gcds-nav-link-top-nav-padding);
      border-inline: 0;
      border-block: var(--gcds-nav-link-border-width) solid transparent;

      &:not(:hover) {
        text-decoration-color: transparent;
      }
    }

    /* Home link styles  */
    :host([slot='home']) > .gcds-nav-link {
      font: var(--gcds-nav-link-top-nav-home-font);
      padding: var(--gcds-nav-link-top-nav-home-padding);
    }
  }

  /* Side-nav: nav link styles */
  :host > .gcds-nav-link--sidenav.gcds-nav-link {
    padding: var(--gcds-nav-link-side-nav-padding);
  }
}

@layer hover {
  @media (hover: hover) {
    :host .gcds-nav-link:hover {
      text-decoration-thickness: var(
        --gcds-nav-link-hover-decoration-thickness
      );
      color: var(--gcds-nav-link-hover-text);
    }

    :host > .gcds-nav-link--sidenav.gcds-nav-link:hover,
    :host > .gcds-nav-link--dropdown.gcds-nav-link:hover {
      color: var(--gcds-nav-link-hover-text);
    }

    :host > .gcds-nav-link--sidenav.gcds-nav-link:hover {
      background-color: var(--gcds-nav-link-side-nav-hover-background);
    }

    :host > .gcds-nav-link--dropdown.gcds-nav-link:hover {
      background-color: var(--gcds-nav-link-top-nav-hover-background);
    }
  }
}

@layer active {
  :host .gcds-nav-link[aria-current='page'] {
    background-color: var(--gcds-nav-link-active-background);
    color: var(--gcds-nav-link-active-text);
    border-inline-start-color: var(--gcds-nav-link-active-border-color);
  }

  :host > .gcds-nav-link--topnav.gcds-nav-link[aria-current='page'] {
    @media only screen and (width >= 64em) {
      background-color: transparent;
      color: var(--gcds-nav-link-top-nav-text);
      border-block-end-color: var(--gcds-nav-link-active-border-color);
    }
  }

  :host > .gcds-nav-link--sidenav.gcds-nav-link[aria-current='page'] {
    font-weight: var(--gcds-nav-link-active-font-weight);
  }
}

@layer focus {
  :host .gcds-nav-link:focus {
    background-color: var(--gcds-nav-link-focus-background);
    color: var(--gcds-nav-link-focus-text);
    outline: var(--gcds-nav-link-focus-outline);
    outline-offset: var(--gcds-nav-link-focus-outline-offset);
    border-color: var(--gcds-nav-link-focus-background);
    text-decoration: none;
    border-radius: var(--gcds-nav-link-focus-border-radius);
    box-shadow: var(--gcds-nav-link-focus-box-shadow);
  }
}
